module.exports = __webpack_public_path__ + "img/mapB.f51a765b.png";